import { render, staticRenderFns } from "./ColumnTransactionStatusOnii.vue?vue&type=template&id=75cde33c&scoped=true"
import script from "./ColumnTransactionStatusOnii.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusOnii.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusOnii.vue?vue&type=style&index=0&id=75cde33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cde33c",
  null
  
)

export default component.exports